'use client';

import * as SubframeCore from '@subframe/core';
import React from 'react';

import { Tooltip } from './Tooltip';

interface TooltipListaProps {
  itens: string[];
  titulo?: string;
  children: React.ReactNode;
}

export function TooltipLista({ itens, titulo, children }: TooltipListaProps) {
  if (itens.length === 0) {
    return <>{children}</>;
  }

  return (
    <SubframeCore.Tooltip.Provider>
      <SubframeCore.Tooltip.Root>
        <SubframeCore.Tooltip.Trigger asChild>{children}</SubframeCore.Tooltip.Trigger>
        <SubframeCore.Tooltip.Portal>
          <SubframeCore.Tooltip.Content side="top" align="center" sideOffset={6} asChild>
            <Tooltip className="max-w-[280px]">
              <span className="flex flex-col gap-1">
                {titulo ? (
                  <span className="text-caption-bold font-caption-bold">{titulo}</span>
                ) : null}
                {itens.map((item, indice) => (
                  <span key={`${indice}-${item}`}>{item}</span>
                ))}
              </span>
            </Tooltip>
          </SubframeCore.Tooltip.Content>
        </SubframeCore.Tooltip.Portal>
      </SubframeCore.Tooltip.Root>
    </SubframeCore.Tooltip.Provider>
  );
}
